module.exports = __webpack_public_path__ + "img/icon-cart.a5ef48ee.svg";